import React, { useEffect } from 'react';
import { Typography, IconButton, Button, Stack } from '@mui/material';
import { Facebook, Twitter, YouTube, Instagram } from '@mui/icons-material';
import PropTypes from 'prop-types';
import StudentRepository from '../services/StudentRepository.js';

export default function Epilogue({ repo }) {
  useEffect(() => {
    repo.logout().catch(console.error);
  }, []);
  return (
    <React.Fragment>
      <Typography variant="body2" color="primary">
        Thank you for taking the time to fill out this form! Your input will help the university in
        its goal of influencing the future!
      </Typography>
      <Typography variant="body2" color="primary">
        Don’t miss out on the updates of your dear Alma Mater in the following social media links:
      </Typography>
      <Stack direction="row" spacing={1}>
        <IconButton href="https://www.facebook.com/msuiit.alumni">
          <Facebook />
        </IconButton>
        <IconButton href="https://twitter.com/msuiit_alumni/">
          <Twitter />
        </IconButton>
        <IconButton href="https://www.youtube.com/channel/UCTpB6EQCQ72pXDkduxmhknw">
          <YouTube />
        </IconButton>
        <IconButton href="https://www.instagram.com/msuiit.alumni/">
          <Instagram />
        </IconButton>
      </Stack>
      <Button variant="contained" size="large" color="error" href="https://giveto.msuiit.edu.ph/">
        Give to MSU-IIT
      </Button>
    </React.Fragment>
  );
}

Epilogue.propTypes = {
  repo: PropTypes.instanceOf(StudentRepository),
};
